import { createSlice } from "@reduxjs/toolkit";
import { IResponseWithPagination } from "src/@types/api";
import { IBlog, IBlogCategoty } from "src/@types/blog";
import { BLOG_SLICE_NAME } from "./actions";
import { getBlogPostsReducer, getBlogCategoriesReducer } from "./reducers";

export interface BlogState {
  posts: IResponseWithPagination<IBlog>;
  isLoadingPosts: boolean;
  categories: IBlogCategoty[];
  isLoadingCategories: boolean;
}

const initialState: BlogState = {
  posts: null,
  isLoadingPosts: false,
  categories: null,
  isLoadingCategories: false,
};

export const { reducer: blog } = createSlice({
  name: BLOG_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    getBlogPostsReducer(builder);
    getBlogCategoriesReducer(builder);
  },
});
